<template>
<!--  <v-text-field v-model="value" @input="sync" :label="label" :readonly="readonly" :placeholder="label" :rules="rules" />-->
  <v-textarea v-model="value" @input="sync" :label="label" :readonly="readonly" :placeholder="label" :rules="rules" />
</template>

<script>
import DefaultField from './default'

export default {
  mixins: [DefaultField],
  data: () => ({
    value: 'integer field'
  }),
  methods: {
    normalize () {
      let norm = this.value.trim()
      this.value = norm
    }
  }
}
</script>
